import React, { Component, Fragment } from 'react'
import { Card, Col, Form, Icon, Input, Tooltip } from 'antd'
import TagSelect from '../../../../../elements/Select/Tag'

const FormItem = Form.Item

class PhoneList extends Component {
  render() {
    const {
      list,
      handleChange,
      getFieldDecorator,
      formItemLayout,
      handleDefault,
      handleRemove,
      title = 'Phone',
      handleAdd,
    } = this.props
    return (
      <Card title={title} type={'inner'} bordered={false} {...formItemLayout}>
        {list
          .filter(f => f.remove !== true)
          .map(e => (
            <Fragment>
              <Col span={8}>
                <FormItem {...formItemLayout}>
                  <TagSelect
                    onChange={handleChange.bind(this, 'phone', e._key, 'tag')}
                    value={e.tag}
                  />
                </FormItem>
              </Col>
              <Col span={11}>
                <FormItem {...formItemLayout}>
                  {getFieldDecorator('phone' + e._key, {
                    initialValue: e.label,
                    rules: [
                      {
                        required: true,
                        message: "Phone Number can't be empty ",
                      },
                    ],
                  })(
                    <Input
                      placeholder="Phone Number"
                      onChange={handleChange.bind(this, 'phone', e._key, 'label')}
                      value={e.label}
                    />,
                  )}
                </FormItem>
              </Col>
              <Col span={1}>
                <Tooltip title={'Set as Default'}>
                  <Icon
                    type={'star'}
                    theme={e.default && 'filled'}
                    style={{
                      fontSize: '13pt',
                      color: '#ceb21b',
                      cursor: 'pointer',
                    }}
                    onClick={!e.default && handleDefault.bind(this, 'phone', e._key)}
                  />
                </Tooltip>
              </Col>
              <Col span={1}>
                <Icon
                  type={'minus-circle'}
                  onClick={handleRemove.bind(this, 'phone', e._key)}
                  style={{ fontSize: '13pt', cursor: 'pointer' }}
                />
              </Col>
            </Fragment>
          ))}
        <Col span={1}>
          <Icon
            type={'plus-circle'}
            onClick={handleAdd.bind(this, 'phone')}
            style={{ fontSize: '13pt', cursor: 'pointer' }}
          />
        </Col>
      </Card>
    )
  }
}

PhoneList.propTypes = {}
PhoneList.defaultProps = {}

export default PhoneList
